import React, { useState } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { Logo } from './Logo';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className="sticky top-0 z-40 w-full bg-white/95 backdrop-blur-sm border-b border-slate-100 shadow-sm" data-id="element-86">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="flex justify-between items-center h-20" data-id="element-88">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-89">
            <a href="/" className="flex items-center" data-id="element-90">
              <Logo data-id="element-91" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-92">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-slate-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-93">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-94">
            <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-slate-800 transition-all hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-95">
              <MessageCircle className="w-4 h-4" data-id="element-96" />
              <span data-id="element-97">WhatsApp Us</span>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-98">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-slate-600 hover:text-slate-900 p-2" aria-label="Toggle menu" data-id="element-99">
              {isMenuOpen ? <X className="w-6 h-6" data-id="element-100" /> : <Menu className="w-6 h-6" data-id="element-101" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-slate-100 absolute w-full shadow-lg" data-id="element-102">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-103">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-slate-600 hover:text-emerald-600 hover:bg-slate-50 rounded-md" data-id="element-104">
                {link.name}
              </a>)}
            <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full mt-4 bg-[#25D366] text-white px-4 py-3 rounded-lg font-bold hover:bg-[#20bd5a]" data-id="element-105">
              <MessageCircle className="w-5 h-5" data-id="element-106" />
              WhatsApp Us
            </a>
          </div>
        </div>}
    </header>;
}